import React from "react";
import PropTypes from "prop-types";

/**
 * 셀러 컬렉션 콘텐츠 컴포넌트
 * 컬렉션의 제목, 부제목, 설명 등의 텍스트 콘텐츠를 렌더링합니다.
 */
const SellerCollectionContent = ({ collection }) => {
  if (!collection) {
    return null;
  }

  return (
    <div className="collection-content">
      <h1 className="collection-title">{collection.title || ""}</h1>

      {collection.description && (
        <p className="collection-description">{collection.description}</p>
      )}
    </div>
  );
};

SellerCollectionContent.propTypes = {
  collection: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }),
};

export default SellerCollectionContent;
